import { getLightBoxImages } from '~/libs/getLightBoxImages';
import { topHeaderContainerHide, topHeaderContainerShow } from '~/utils';

export function useLightboxGallery(content: TContent[]) {
  const images = ref<TContent[]>([]);
  const currentImageId = ref(0);
  const isGalleryVisible = ref(false);

  const imagesSrc = computed(() =>
    images.value.filter((i) => !!i.attributes?.src).map((i) => i.attributes?.src),
  );

  const imagesSrcset = computed(() =>
    images.value.filter((i) => !!i.attributes?.srcset).map((i) => i.attributes?.srcset),
  );

  const openGallery = (index: number) => {
    if (index > -1) {
      currentImageId.value = index;
    }
    isGalleryVisible.value = true;
    topHeaderContainerHide();
  };

  const closeGallery = () => {
    isGalleryVisible.value = false;
    currentImageId.value = 0;
    topHeaderContainerShow();
  };

  const checkImageClick = (event: MouseEvent) => {
    if (!event || !event.composedPath) {
      return;
    }

    // ссылка ли lightbox-gallery
    const lightBoxGalleryAnchor = event.composedPath().find((item: EventTarget) => {
      return (
        item instanceof HTMLAnchorElement && item.dataset?.rel?.indexOf('lightbox-gallery') === 0
      );
    });

    if (lightBoxGalleryAnchor instanceof HTMLAnchorElement) {
      const image = lightBoxGalleryAnchor.querySelector('img');

      if (image instanceof HTMLImageElement) {
        const { src } = image as HTMLImageElement;
        const index = imagesSrc.value.indexOf(src);
        openGallery(index);
        event.preventDefault();
      }
    }
  };

  onMounted(() => {
    images.value = content.reduce((acc: TContent[], curr: TContent) => {
      const currentImageNodes = getLightBoxImages(curr);
      return [...acc, ...currentImageNodes];
    }, []);
  });

  return {
    imagesSrc,
    imagesSrcset,
    currentImageId,
    isGalleryVisible,
    openGallery,
    closeGallery,
    checkImageClick,
  };
}
